import React, { useState } from "react";

const Trusted: React.FunctionComponent = () => {
  const [realtimeHover, setRealtimeHover] = useState<boolean>(false);
  const [scheduledHover, setScheduledHover] = useState<boolean>(false);
  const [chatroomHover, setChatroomHover] = useState<boolean>(false);

  const items = [
    {
      imageLink: "realtime.png",
      imageHoverLink: "realtime-hovered.png",
      imageName: "realtime",
      title: "REAL-TIME",
      text: "Get matched and play in real-time with your partners",
      state: realtimeHover,
      setState: (state) => setRealtimeHover(state),
    },
    {
      imageLink: "/scheduled.svg",
      imageHoverLink: "scheduled-hovered.png",
      imageName: "scheduled",
      title: "SCHEDULED",
      text: "Need to eat your lunch? Schedule the match-up for later",
      state: scheduledHover,
      setState: (state) => setScheduledHover(state),
    },
    {
      imageLink: "/chatroom.png",
      imageHoverLink: "chatroom-hovered.png",
      imageName: "chatroom",
      title: "CHATROOM",
      text: "You're chatting with your match partners instantly",
      state: chatroomHover,
      setState: (state) => setChatroomHover(state),
    },
  ];

  return (
    <div className="relative overflow-hidden py-24 text-black">
      <div className="container max-w-6xl">
        <div className="flex flex-col justify-center items-center">
          <h2 className="nunito-sans max-w-2xl font-bold text-yellow-300 text-center text-5xl leading-tight tracking-wide mb-3">
            That's not all
          </h2>

          <div className="mb-24">
            <p className="nunito-sans text-2xl text-blue-100 opacity-75 text-center">
              The app is more than a place to get better at gaming
            </p>
          </div>

          <div className="grid md:grid-cols-3 mb-6 gap-x-8">
            {items.map(
              (
                {
                  imageLink,
                  imageHoverLink,
                  imageName,
                  title,
                  text,
                  state,
                  setState,
                },
                index
              ) => (
                <div
                  key={index}
                  className="flex flex-col items-center md:items-start mb-10"
                  onMouseEnter={() => setState(true)}
                  onMouseLeave={() => setState(false)}
                >
                  <div className="relative w-16 h-16 mb-3">
                    <img
                      src={imageLink}
                      alt={imageName}
                      className={`absolute top-0 left-0 -ml-2 flex-shrink-0 transition duration-200 transform  ${
                        state
                          ? "opacity-0 -translate-y-3"
                          : "opacity-100 translate-y-0"
                      }`}
                    />
                    <img
                      src={imageHoverLink}
                      alt={imageName}
                      className={`absolute top-0 left-0 -ml-2 flex-shrink-0 transition duration-200 transform  ${
                        state
                          ? "opacity-100 -translate-y-3"
                          : "opacity-0 translate-y-0"
                      }`}
                    />
                  </div>

                  <p className="text-yellow-300 font-bold text-lg tracking-wider mb-4">
                    {title}
                  </p>
                  <p className="text-blue-200 text-center md:text-left">{text}</p>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Trusted;
